////////////////////////////////////////////////////////
import { SkinCard } from '@/app/shared/components';
import { useCustomSelector } from '@/core/redux/hooks';

export const SkinsList: React.FC = () => {
	/*********************
	// #region Redux
	**********************/
	const { skins } = useCustomSelector((state) => state.skins);

	/*********************
	// #region Template
	**********************/
	return (
		<div className="grid gap-4 ">
			{skins &&
				skins.map((item) => <SkinCard skin={item} key={item.name} />)}
		</div>
	);
};
